import { useEffect, useRef, useState } from 'react';
import { Tooltip, withStyles } from '@material-ui/core';

function OverflownText({ data }) {
  const ref = useRef(null);
  const [isOverflown, setIsOverflown] = useState(true);

  useEffect(() => {
    const element = ref.current;
    setIsOverflown(element.firstChild.scrollWidth > element.clientWidth);
  }, [ref.current]);

  return <WhiteTooltip
    disableFocusListener={!isOverflown}
    disableHoverListener={!isOverflown}
    disableTouchListener={!isOverflown}
    placement={'top'}
    title={
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 5,
        flexDirection: 'column',
      }}>
        {data}
      </div>
    }
  >
    <div ref={ref} style={{
      maxWidth: '100%',
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      '-webkit-mask-image': isOverflown ? 'linear-gradient(90deg, #000 70%, transparent)' : 'none',
    }}>
      <div style={{
        whiteSpace: 'nowrap',
        display: 'flex',
        height: '100%',
        width: 'fit-content',
        backgroundColor: 'transparent',
        transition: 'background-color .3s ease-in, font-weight .3s ease-in',
        overflow: 'hidden',
        gap: 5,
        alignItems: 'center'
      }}>

        {data}
      </div>
    </div>
  </WhiteTooltip>;
}

export default OverflownText;

const WhiteTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#fff',
    boxShadow: theme.shadows[3],
    padding: 12,
    position: 'relative',
    maxWidth: 'fit-content',
  },
}))(Tooltip);
